export const PORTAL_URL = "https://apps.datacenterwest.com";
export const API_BASE_URL = "https://apps.datacenterwest.com";
export const LOGIN_URL = `${PORTAL_URL}/login.php`;
export const PAIRING_URL = `${PORTAL_URL}/pairing.php`;
export const PWA_APP_URL = `${PORTAL_URL}/app/`;
